import $ from 'jquery';

const ACTIVE = 'active';
const footerNav = () => {
  const subnavToggle = $('[data-footer-children]');
  if (subnavToggle && subnavToggle.length) {
    subnavToggle.on('click', ev => {
      ev.preventDefault();
      let $self = $(ev.target);
      if (!$self.hasClass('c-footer__link')) {
        $self = $self.closest('.c-footer__link');
      }
      const parent = $self.closest('.c-footer__item');
      if (!parent.hasClass(ACTIVE)) {
        subnavToggle.parent().removeClass(ACTIVE);
        parent.addClass(ACTIVE);
      } else {
        parent.removeClass(ACTIVE);
      }
    });
  }
};
export default footerNav;



// WEBPACK FOOTER //
// ./src/scripts/modules/footer-nav.js